export const TIPS_ARM = {
  CONTROL: 'control',
  A: 'a',
} as const;

export const TIPS_ENTRY_PAGES: readonly string[] = ['verify-email', 'supplements'];
